// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"calendar-3"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M21 10.5V5.5H3V10.5H21Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill1","fill":"transparent","d":"M3 21.5L21 21.5V10.5L3 10.5L3 21.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M7 18H15M7 14H11","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 10.5V21.5H3V10.5M21 10.5H3M21 10.5V5.5H3V10.5M7 5.5V2.5M17 5.5V2.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-calendar-3')
export default class Calendar3Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calendar-3',
    }
  }
}
